interface CourseFileBadgeProps {
  loaded: boolean;
  loadedLabel: string;
  notLoadedLabel: string;
}

const BG = {
  loaded: '#CEF0DA',
  notLoaded: '#F2C0BD',
};

export default function CourseFileBadge({
  loaded,
  loadedLabel,
  notLoadedLabel,
}: CourseFileBadgeProps) {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <div
        className="d-flex align-items-center justify-content-start"
        style={{ gap: 8, width: 120 }}
      >
        <div
          className="border border-primary"
          style={{
            width: 20,
            height: 20,
            backgroundColor: loaded ? BG.loaded : BG.notLoaded,
            flexShrink: 0,
          }}
        />
        <span>{loaded ? loadedLabel : notLoadedLabel}</span>
      </div>
    </div>
  );
}
